module.exports = __webpack_public_path__ + "img/free-score-hero.4e998231.jpg";